import React from "react";
import { ReactElement } from "react";
import { ButtonBase, Paper, Radio, Stack, Typography, useTheme } from "@mui/material";

interface Props {
    label: string;
    icon: ReactElement;
    isChecked: boolean;
    onChange: () => void;
}

const PaymentMethod = ({ label, icon, isChecked, onChange }: Props) => {
    const { palette } = useTheme();

    const color = isChecked ? palette.primary.main : 'black';

    return (
        <ButtonBase
            onClick={onChange}
            sx={{
                borderRadius: 3,
            }}
        >
            <Paper
                sx={{
                    py: 3,
                    pl: 1.5,
                    pr: 3,
                    width: '100%',
                    borderRadius: 3,
                    position: 'relative',

                    ['&::after']: {
                        content: "''",
                        position: 'absolute',
                        left: 0,
                        top: 0,
                        width: '100%',
                        height: '100%',
                        borderRadius: 3,
                        boxShadow:
                            isChecked
                                ? `0px 0px 0px 3px inset ${palette.primary.main}`
                                : 'unset',
                    }
                }}
            >
                <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                >
                    <Stack direction="row" alignItems="center" spacing={3} pl={2}>
                        {React.cloneElement(icon, { color, size: 32, strokeWidth: 1.75 })}
                        <Typography
                            variant="body1"
                            fontSize={20}
                            fontWeight={400}
                            color={color}
                        >
                            {label}
                        </Typography>
                   </Stack>
                    <Radio size="medium" color={"primary"} checked={isChecked} />
                </Stack>
            </Paper>
        </ButtonBase>
    )
}

export default PaymentMethod;
